// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__g4a-5","right":"styles_right__2bWOP"};